import { gql } from "graphql-request";
import purchaseGraphqlClient from "./purchaseGraphqlClient";

export const AUTH_CREATE_PURCHASE = gql`
  mutation AUTH_CREATE_PURCHASE($params: AuthCreatePurchaseInput!) {
    auth_create_purchase(params: $params) {
      uuid
      stripe_invoice
      stripe_invoice_id
    }
  }
`;

export interface AuthCreatePurchaseInput {
  data: any;
}

export interface AuthCreatePurchaseResponse {
  uuid: string;
  stripe_invoice?: any;
  stripe_invoice_id?: string;
}

interface AuthCreatePurchaseGQLResponse {
  auth_create_purchase: AuthCreatePurchaseResponse;
}

export async function authCreatePurchase(
  token: string | null,
): Promise<AuthCreatePurchaseResponse> {
  if (!token) {
    throw new Error("Authentication token is required for authenticated purchase creation");
  }

  console.log("authCreatePurchase: Creating purchase");

  const data = await purchaseGraphqlClient.request<AuthCreatePurchaseGQLResponse>(
    AUTH_CREATE_PURCHASE,
    { params: { data: {} } },
    token,
  );

  console.log("authCreatePurchase: Response received:", data);

  return data.auth_create_purchase;
}
